import styles from "./style.module.scss";
import { Link } from "react-router-dom";
import Diving01 from "src/assets/activity/diving/01.jpg";
import Diving02 from "src/assets/activity/diving/02.jpg";
import Diving03 from "src/assets/activity/diving/03.jpg";
import Diving04 from "src/assets/activity/diving/04.jpg";
import Diving05 from "src/assets/activity/diving/05.jpg";
import Diving06 from "src/assets/activity/diving/06.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IMAGES = [Diving01, Diving02, Diving03, Diving04, Diving05, Diving06];

export const DivingSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <p id="diving" className={styles.sectionTitle}>
          ダイビングで四季のある海の中へ
        </p>

        <Slider {...settings}>
          {IMAGES.map((src, i) => (
            <img src={src} alt={`slide-${i}`} key={i} />
          ))}
        </Slider>

        <p className={styles.description}>
          海の中の景色は、四季とともに驚くほど変化します。この体験では、南国にはない季節ごとに表情を変える海の魅力を間近で感じることができます。慣れてくると、普段は見ることができない牡蠣やホタテの養殖棚も海の中から観察可能。ダイビングショップ「ダイビングハイブリッジ」のプロダイバーの徹底した安全管理の元、初心者でも楽しくダイビングをすることができます。
        </p>
        <h3>information -詳細情報-</h3>

        <ul>
          <li>
            <p className={styles.head}>体験場所</p>
            <p className={styles.body}>
              <span style={{ textAlign: "center" }}>
                竹浦漁港
                <br />
                （〒986-2203 宮城県牡鹿郡女川町竹浦）など。
              </span>
            </p>
          </li>
          <li>
            <p className={styles.head}>体験人数</p>
            <p className={styles.body}>1〜4名</p>
          </li>
          <li>
            <p className={styles.head}>体験可能時間</p>
            <p className={styles.body}>8:00〜16:00</p>
          </li>
          <li>
            <p className={styles.head}>所要時間</p>
            <p className={styles.body}>8時間</p>
          </li>
          <li>
            <p className={styles.head}>料金</p>
            <p className={styles.body}>
              1名あたり28,000円（ダイビング器具一式レンタル込）
            </p>
          </li>
          <li>
            <p className={styles.head}>予約方法</p>
            <p className={styles.body}>
              <Link to="/reservation">ご予約ページ</Link>で選択ください
            </p>
          </li>
        </ul>
        <p className={styles.ulInfo}>
          ※料金は時期などによって変動する可能性があるため、詳しくは店舗にご確認ください。
        </p>
      </div>
    </section>
  );
};
